import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthCallbackComponent} from './auth-callback/auth-callback/auth-callback.component';
import {authGuard} from './auth.guard';
import {UnauthorizedPageComponent} from './unauthorized-page/unauthorized-page.component';
import {CryptMultipleComponent} from './crypt-multiple/crypt-multiple.component';
import {HealthComponent} from './health/health/health.component';
import {ErrorPageComponent} from './error-page/error-page.component';

const routes: Routes = [
  { path: 'health', component: HealthComponent },
  { path: 'crypt', component: CryptMultipleComponent, canActivate: [authGuard()] },
   { path: 'auth', component: AuthCallbackComponent},
  { path: 'error', component: ErrorPageComponent},
  { path: 'unauthorized', component: UnauthorizedPageComponent, canActivate: [authGuard()]},
   { path: '',   redirectTo: '/crypt', pathMatch: 'full' },
  { path: '**',   redirectTo: '/crypt', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
